/* global localStorage */

import * as MutationTypes from './mutation-types'
import { mapGetters, mapState, mapSetters } from 'vuex'
import axios from '../backend/vue-axios'

const getDefaultState = () => {
  return {
    id: false,
    address: [{
      zip: '',
      city: '',
      street: '',
      number: '',
      firstname: '',
      lastname: '',

    }],
    softfair_hsn: null,
    softfair_tsn: null,
    softfair_erstmalige_zulassung_auf_versicherungsnehmer: null,
    softfair_fahrzeug_nutzung: null,
    softfair_ausland_nutzung: null,
    softfair_fahrleistung_pro_jahr: null,
    softfair_kilometerstand: null,
    softfair_erstzulassungs_datum: null,
    softfair_ist_als_betriebsausgabe_anerkannt: null,
    softfair_stellplatz_art: null,
    softfair_ist_erstbesitzer: null,
    softfair_neuwert_euro: null,
    softfair_manuelle_typklassen: null,
    softfair_tagfahrlicht: null,
    softfair_unfalldatenschreiber: null,
    softfair_abstandsregeltempomat: null,
    softfair_antiblockiersystem: null,
    softfair_elektronisches_stabilitaetsprogramm: null,
    softfair_spurhalteassistent: null,
    softfair_spurwechselassistent: null,
    softfair_elektronische_diebstahlwarnanlage: null,
    softfair_nachtsichtassistent: null,
    softfair_bremsassistent: null,
    softfair_fahrzeugortungssystem: null,
    softfair_elektronische_wegfahrsperre: null,
    job: null,
    softfair_beruf: null,
    softfair_fuehrerscheindatum: null,
    license_date: null,
    is_company: null,
    softfair_stellung: null,
    softfair_hat_jahreskarte_oeffentlicher_personenverkehr_zusatz: null,
    softfair_ist_mitarbeiter_autohersteller: null,
    softfair_tarifgruppe: null,
    softfair_hat_an_sicherheitstraining_teilgenommen_datum: null,
    softfair_hat_fuehrerschein_in_eu_erworben: null,
    softfair_arbeitgeber_branche: null,
    softfair_hat_punkte_in_flensburg: null,
    softfair_branche: null,
    softfair_spezieller_arbeitgeber: null,
    softfair_hat_wohnsitz_seit_mindestens_5_jahren: null,
    softfair_ist_vorsteuer_abzugsberechtigt: null,
    softfair_hat_am_begleiteten_fahren_teilgenommen: null,
    softfair_familienstand: null,
    softfair_wohneigentum_typ: null,
    softfair_wohneigentum_versicherung_id: null,
    softfair_wohneigentum_ist_vermietet: null,
    softfair_wohneigentum_anzahl_versicherte_gefahren: null,
    dob: null,
    softfair_geburtsdatum: null,
    softfair_kunde_person_id: null,
    city: null,
    zip: null,
    option_schutzbrief: null,
    option_gap: null,
    option_discount_protection: null,
    option_fahrerschutz: null,
    softfair_diebstahl_elektro_kabel: null,
    softfair_deckungssummen_haftpflicht: null,
    softfair_rabattschutz_haftpflicht: null,
    softfair_akku_fehler_durch_bedienung: null,
    softfair_ausgleich_akku_leasing: null,
    softfair_umweltschadenversicherung: null,
    softfair_rabattschutz_vollkasko: null,
    softfair_recht_auf_schadenruekauf_kasko: null,
    softfair_hacker_und_cyber_angriff: null,
    softfair_neuwertentschaedigung_akku: null,
    softfair_pannenhilfe_akku: null,
    softfair_betriebs_brems_bruchschaeden: null,
    softfair_verzicht_auf_selbstbeteiligung_bei_glasreparatur: null,
    softfair_verzicht_auf_abzug_neu_fuer_alt: null,
    softfair_personen_deckungssumme_haftpflicht: null,
    softfair_neuwertentschaedigung: null,
    softfair_ueberfuehrungskosten: null,
    softfair_zusatzleistungen_elektro_und_hybridfahrzeuge: null,
    softfair_schaeden_zwischeniehendem_und_gezogenem_fahrzeug: null,
    softfair_dachlawinen: null,
    softfair_parkschadenschutz: null,
    softfair_kosten_fuer_wassercontainer: null,
    softfair_auslandschadenschutz: null,
    softfair_eigenschadendeckung: null,
    softfair_wertminderungsausgleich_bei_reparaturschaeden: null,
    softfair_all_risk_akku_elektro: null,
    softfair_mobile_ladegeraete: null,
    softfair_ueberspannungsschaeden_am_akku: null,
    softfair_entsorgungskosten: null,
    softfair_werkstattbindung: null,
    softfair_tierbissfolge_schaeden: null,
    softfair_entsorgungskosten_akku: null,
    softfair_all_risk: null,
    softfair_unfallmeldedienst: null,
    softfair_zulassungskosten: null,
    softfair_verzicht_auf_einwand_grober_fahrlaessigkeit: null,
    softfair_kurzschlussfolgeschaeden_elektro: null,
    softfair_recht_auf_schadenruekauf_kh: null,
    softfair_kaufwertentschaedigung: null,
    softfair_diebstahl_elektro_ladekarte: null,
    softfair_mallorcapolice: null,
    softfair_telematik: null,
    softfair_akku_ausgleich_leasing_akku: null,
    softfair_sonstige_leistungen_elektro_hybridfahrzeuge: null,
    softfair_leistungs_update_garantie: null,
    softfair_tierbiss_folgeschaeden_elektro: null,
    softfair_elementarschaeden: null,
    softfair_wallboxen: null,
    softfair_beitragsfrei_mitversicherter_mehrwert: null,
    softfair_kurzschlussfolgeschaeden: null,
    softfair_kollision_mit_tieren: null,
    has_holder: null,
    softfair_vn_ist_fahrer: null,
    softfair_vn_ist_hauptnutzer: null,
    softfair_nutzfahrzeug: null,
    softfair_schadenfreiheitsklasse_vollkasko: null,
    softfair_selbstbeteiligung_kasko: null,
    softfair_finanzierung: null,
    softfair_rueckstufung_beruecksichtigen: null,
    softfair_geschaeftsvorfall: null,
    softfair_zahlungs_art_und_weise: null,
  }
}

const state = getDefaultState()

const getters = {
  getSoftfairOfferData(state) {
    return state
  }
}

const actions = {
  resetSoftfairOffer({ commit }) {
    commit('resetState')
  },
  fetchSoftfairOffer({ commit }, token) {
    axios.get("/spa/softfair_offers/" + token).then((response) => {
      commit('setSoftfairOfferItems', response.data.insurance)
    })
      .catch((e) => {
        console.log(e)
      })
  },
  saveSoftfairOffer({ commit, state }) {
    axios.post("/spa/softfair_offers/", { softfair_offer: state }).then((response) => {
      console.log(response);
      commit('setSoftfairOfferItems', response.data.softfair_offer)
    })
      .catch((e) => {
        console.log(e)
      })
  },
  setOfferData({ commit, dispatch }) {
    commit('setSoftfairOffer', state)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations: {
    setSoftfairOfferItems(state, offerData) {
      state = Object.assign(state, offerData)
    },
    setSoftfairOffer(state, item) {
      state = Object.assign(state, item)
    },
    resetState(state) {
      Object.assign(state, getDefaultState())
    }
  }
} 